<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <polymorphic-reference-show :id="id"></polymorphic-reference-show>
  </div>
</template>

<script>
import PolymorphicReferenceShow from './PolymorphicReferenceShow.vue'

export default {
  components: {
    PolymorphicReferenceShow
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>